import dynamic from 'next/dynamic';

const MapComponent = dynamic(async () => await import('./InnerMap'), {
  ssr: false,
});

export { MapComponent };
